<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-interactions-contact-reasons-update-topic">
    <el-dialog
      v-if="visible"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      append-to-body
      custom-class="topicNameConflictDialog-interactions-dialog">
      <span slot="title" class="dialog-title">Rename Topic</span>
      <div class="update-topic-name"  v-loading="loading">
        
        <div class="div-topic-name-input">
          <el-input ref="topicNameInput" placeholder="" maxlength="50" show-word-limit v-model="topicName" autofocus="true" @keypress.enter.native="handleUpdateName"></el-input>
        </div>
         <div v-if="topicName.trim()===''" class="conflict-msg">The AI-generated topic can't be empty. Please enter a new name.</div>
        <div v-else-if="isDisabled&&topicName.trim().toLowerCase()==='others'" class="conflict-msg">The AI-generated topic can't be "others". Please enter a new name.</div>
        <div v-else-if="isDisabled" class="conflict-msg">The AI-generated topic "{{topicName}}" already exists. Please enter a new name.</div>
        <!-- <div v-else-if="isDisabled" class="conflict-msg">The AI-generated topic "{{topicName}}" already exists. Please enter a new name.</div> -->
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-cancel" @click="handleClose">Cancel</el-button>
          <el-button :disabled="isDisabled" class="primary-btn btn-confirm" type="primary" @click="handleUpdateName">Save</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-interactions-contact-reasons-update-topic',
  props: ['controller'],

  data() {
    return {
      visible: false,
      currentRow: null,
      topicName: '',
      topicNameObject: null,
      isDuplicatedError: false,
      loading: false
    }
  },

  computed: {
    isDisabled() {
      return this.topicName.trim()=='' || this.topicName.trim() == this.topicNameObject.newTopicDisplayName || this.topicName.trim() == this.topicNameObject.oldTopicDisplayName || this.topicName.trim().toLowerCase() == 'others' ;
    }
  },

  methods: {
    handleUpdateName() {
      if(this.controller.updateTableData && !this.isDisabled) {
        this.loading = true;
        this.controller.updateTableData(this.currentRow, "topicDisplayName", this.topicName.trim(), ({error}) => {
          if(error) {
            this.isDuplicatedError = error;
          }
          else {
            this.handleClose();
          }
          this.loading = false;
        });
      }
    },

    handleOpen(row, topicNameObject) {
      this.currentRow = row;
      this.topicName = topicNameObject.newTopicDisplayName;
      this.topicNameObject = topicNameObject;
      this.visible = true;
    },

    handleClose() {
      this.visible = false;
    }
  },

  created() {
    this.topicName = this.controller.topicName;
  }
});
</script>

<style lang="scss">
.topicNameConflictDialog-interactions-dialog {
    width: 567px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #FFF;
    border-radius: 5px;
    
  .el-dialog__body {
    padding: 0px 20px 20px 20px;
  }
  .div-topic-icon {
    background-image: url('../../../assets/icons/icon_warning_wys.png') !important;
    background-size: 135px;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 30px;
    height: 168px;
    width: 30%;
    text-align: center;
    padding: 0px 46px 25px 0px;
    font-weight: 600;
    display: inline-block;
  }
  .div-topic-label {
    display: inline-block;
    font-weight: 500;
    font-size: 21px;
    color: var(--site-font-primary-color);
    width: 280px;
    word-break: keep-all;
    vertical-align: 63px;
  }
  .div-topic-name-input {
    padding: 0px;

    input.el-input__inner {
      border: 1px solid #cad2da;
      height: 38px;
      padding: 0 10px;
      border-radius: 5px;
      width: 100%;
      border-width: 1px !important;
    }
    .el-input .el-input__count .el-input__count-inner {
      position: relative;
      top: 30px;
      left: 10px;
    }
  } 
  .red-warning {
    text-align: left;
    // font: italic normal normal 13px/16px Lato;
    font-style: italic;
    font-size: 11px;
    letter-spacing: 0px;
    color: #D54545;
    opacity: 1;
    padding-left: 37px;
    padding-top: 7px;
  }
  .conflict-msg {
    text-align: left;
    word-break: break-word;
    flex-flow: unset;
    padding: 20px 0px;
    font-size: 12px;
    color: #f47676;
    font-weight: 400;
  }
  .el-dialog__header {
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    height: 50px;
    display: flex;
    border-bottom: 1px dashed #cad2da;
    font-weight: 500;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 25px;
    margin: 0 20px 25px 20px;
    padding: 15px 0px 10px;
  }
  .dialog-footer {
    text-align: right;
    margin-top: 20px;
    .btn-cancel {
      border: unset;
      color: var(--site-button-cancel-btn-primary-color) !important;
      padding: 7px 30px 7px 30px;
      font-size: 14px;
      height: 36px;
    }
    .btn-cancel:hover {
      background-color: transparent;
    }
    .btn-cancel:focus {
      background-color: transparent;
    }
    .btn-confirm {
      float: right;
      padding: 8px 16px 8px 16px !important;
      font-size: 15px;
      cursor: pointer;
      font-family: Helvetica Neue, Arial, sans-serif;
      border-radius: 5px;
      margin-right: 0px;
      width: 68px;
    }
  }
}
</style>